import { render, staticRenderFns } from "./CInterpretationStats.vue?vue&type=template&id=495b7a5c&scoped=true&"
import script from "./CInterpretationStats.vue?vue&type=script&lang=js&"
export * from "./CInterpretationStats.vue?vue&type=script&lang=js&"
import style0 from "./CInterpretationStats.vue?vue&type=style&index=0&id=495b7a5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495b7a5c",
  null
  
)

export default component.exports